export default "__VITE_ASSET__09798ac6__"